// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCHRdcXIihoXP48VHHU0Io0mdvVLP7S2VA",
  authDomain: "bp3-project.firebaseapp.com",
  projectId: "bp3-project",
  storageBucket: "bp3-project.firebasestorage.app",
  messagingSenderId: "412748360143",
  appId: "1:412748360143:web:e9c435287a63f64e39caba"
};

// VAPID key for web push notifications
export const VAPID_KEY = 'BFWggx00OoPNqVtmcdPJxzq9qwM5ykab4i8Uu_u8wvBlAt83ep6ExLsLGjb4qgvhhEFeEJErVGz6lsVQDWyOrRQ';

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
let messagingInstance = null;

export const initializeMessaging = async () => {
  try {
    if (!await isSupported()) {
      console.log('Firebase messaging is not supported in this browser');
      return null;
    }
    
    if (!messagingInstance) {
      messagingInstance = getMessaging(app);
      console.log('Firebase messaging initialized successfully');
    }
    return messagingInstance;
  } catch (error) {
    console.error('Error initializing Firebase messaging:', error);
    return null;
  }
};

export const getMessagingInstance = () => messagingInstance; 